// Responsive srcset helper for Unsplash-hosted imagery.
// Rewrites the `w=` param and adds `auto=format` so the CDN serves WebP/AVIF.
export function unsplashSrcSet(url, widths = [640, 960, 1280, 1920], q = 75) {
  return widths
    .map((w) => `${url.replace(/([?&])w=\d+/, `$1w=${w}`).replace(/([?&])q=\d+/, `$1q=${q}`)}&auto=format ${w}w`)
    .join(", ");
}

export function unsplashSrc(url, w = 1280, q = 75) {
  return `${url.replace(/([?&])w=\d+/, `$1w=${w}`).replace(/([?&])q=\d+/, `$1q=${q}`)}&auto=format`;
}
